import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';
import DisplayLineGraph from './LineGraphView';
import PictographsView from './PictographsView';
import DisplaySuggestions from './SustainabilitySuggestionsView';



export default class DisplayDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      billData: null,
    }
  }

  componentDidMount() {
    this.setState({billData: this.props.billData});
  }
  
  render(){
    let welcomeMessage; 
    if (this.props.user.displayName != null) {
      let firstName = this.props.user.displayName.split(" ");
      welcomeMessage = "Welcome back, " + firstName[0].charAt(0).toUpperCase() + firstName[0].slice(1) + "!"; 
    } else {
      welcomeMessage = 'Welcome Back!';
    }
    
    return (
      <div className='container dashboard-container'>
        <div className='top-container'>
          <DisplayLineGraph signedIn={this.props.signedIn} user={this.props.user} billData={this.state.billData}/>
           <div className="top-left">
             <h1 className='greeting'>{welcomeMessage}</h1>
             <h2 className="overview">Here's your monthly overview.</h2>
             <DisplaySuggestions/>
           </div>
            
        </div>        
              

        <div className='bottom-container mb-3'>
           <PictographsView signedIn={this.props.signedIn} user={this.props.user} billDataCallback={this.billDataCallback}/>
           <div className='button-container'>
             <NavLink className='green-button dash-button p-4' to='/input'>Input your Bills</NavLink>
             <NavLink className='green-button dash-button p-4' to='/pastbills/water'>View Past Bills</NavLink>
           </div>
         </div>
       </div>
      
    )
  }
}